import styled from 'styled-components';
import SafeAndHygienicSvg from '../../../assets/onboarding/newHome/safe-and-hygienic.svg';

const SafeAndHygienicIcon = styled(SafeAndHygienicSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '4.2rem'};
height: ${props => props.height || '4.2rem'};
display: flex;
`;

export default SafeAndHygienicIcon;
